import React from "react";
import { Box, DialogTitle, DialogContent, DialogActions, Typography, IconButton, TextField, Button } from "@mui/material";
import { X } from "@phosphor-icons/react";
import { useFormik } from "formik";
import { object, string } from 'yup';
import { MAX_CHARS } from "../../enums/generalEnums";

const validationSchema = object({
  context: string().required("Context is required").max(MAX_CHARS),
});

export default function ReportCreatorForm({ onSubmit, onClose, isLoading }) {
  const formik = useFormik({
    initialValues: { context: "" },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      onSubmit(values, resetForm);
    },
  });

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <DialogTitle sx={{ m: 0, p: 0 }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "100%",
              textAlign: "center",
              color: "primary.main",
            }}
          >
            Report Profile
          </Typography>
        </DialogTitle>
        <IconButton aria-label="close" onClick={onClose} sx={{ color: (theme) => theme.palette.grey[500] }}>
          <X />
        </IconButton>
      </Box>

      <DialogContent>
        <Typography color="textSecondary" variant="body1" fontWeight={700}>
          Provide Context <span style={{ color: "#F96D82" }}>*</span>
        </Typography>

        <TextField
          name="context"
          rows={6}
          fullWidth
          multiline
          value={formik.values.context}
          onChange={(e) => {
            if (e.target.value.length <= MAX_CHARS) {
              formik.setFieldValue("context", e.target.value);
            }
          }}
          onBlur={formik.handleBlur}
          error={formik.touched.context && Boolean(formik.errors.context)}
          helperText={formik.touched.context && formik.errors.context}
        />

        <Typography variant="caption" color={formik.values.context.length >= MAX_CHARS - 50 ? "error" : "textSecondary"}>
          {`${MAX_CHARS - formik.values.context.length} characters remaining`}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button type="submit" disabled={isLoading} variant="contained" fullWidth>
          Submit Report
        </Button>
      </DialogActions>
    </Box>
  );
}
